// QC #42 — KH cần "Cài đặt" để chuyển trạng thái chiến dịch
// (Chờ → Đang triển khai → Đã kết thúc / Reopen). Spec §3.1.
import { useMutation } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { useCallApi } from '@/hooks/useCallApi';
import { INetworkResponse, MutationOptions } from '@/models';

type Payload = { id: string; status: string };

export function useUpdateStatusRecruitmentPlan(
  options?: MutationOptions<unknown, Payload>
) {
  const { handleCallApi } = useCallApi();

  function mutationFn(payload: Payload) {
    return handleCallApi(
      () =>
        axiosClient.patch('/recruitment-plan/update-status', payload) as Promise<
          INetworkResponse<unknown>
        >,
      true,
      'Cập nhật trạng thái chiến dịch thành công'
    );
  }

  return useMutation(mutationFn, options);
}
